import React, { useEffect, useState } from 'react';

const HEADLINE = 'We build the AI that runs your business.';

const TypedHeadline: React.FC = () => {
  const [count, setCount] = useState(0);
  const done = count >= HEADLINE.length;

  useEffect(() => {
    if (done) return;
    const start = setTimeout(() => setCount((c) => c + 1), count === 0 ? 250 : 45);
    return () => clearTimeout(start);
  }, [count, done]);

  return (
    <h1
      aria-label={HEADLINE}
      className="relative text-5xl md:text-7xl font-semibold text-black leading-[1.05] tracking-[-0.035em] mb-8 max-w-4xl"
    >
      <span aria-hidden="true" className="invisible">{HEADLINE}</span>
      <span aria-hidden="true" className="absolute inset-0">
        {HEADLINE.slice(0, count)}
        <span
          className={`inline-block w-[2px] md:w-[3px] h-[0.85em] align-[-0.1em] bg-black ml-1 ${
            done ? 'animate-blink' : ''
          }`}
        />
      </span>
    </h1>
  );
};

const Hero: React.FC = () => {
  return (
    <section className="bg-white">
      <div className="container-max section-padding pt-28 md:pt-40 pb-12 md:pb-16">
        <TypedHeadline />

        <p className="text-lg md:text-xl text-neutral-600 max-w-2xl mb-10 leading-relaxed">
          We build AI agents, RAG chatbots, LLM applications, and workflow automations
          that help businesses operate smarter, not just experiment with AI.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 mb-24">
          <a
            href="https://calendar.app.google/cnN9KoLp6WZYMX9G7"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center bg-black hover:bg-neutral-800 text-white text-base font-medium px-7 py-3.5 rounded-full transition-colors"
          >
            Book a free 30-min call
          </a>
          <a
            href="#services"
            className="inline-flex items-center justify-center bg-white text-black border border-neutral-200 hover:border-neutral-900 text-base font-medium px-7 py-3.5 rounded-full transition-colors"
          >
            See what we build
          </a>
        </div>

        <div className="flex flex-wrap gap-x-12 gap-y-6">
          {[
            { value: '5.0', label: 'Upwork rating' },
            { value: '100%', label: 'Job success' },
            { value: '3+', label: 'Ongoing clients' },
            { value: 'Ireland', label: 'Based · remote' },
          ].map((stat) => (
            <div key={stat.label}>
              <p className="text-2xl md:text-3xl font-semibold text-black tracking-tight">{stat.value}</p>
              <p className="text-sm text-neutral-500 mt-1">{stat.label}</p>
            </div>
          ))}
        </div>

        <p className="sr-only">
          Zwift Labs is an AI consulting company, AI software company, freelancer, and contractor based in Ireland, available globally.
          Services include AI consulting Ireland, Voice AI development, conversational AI, AI agents, LLM applications, RAG pipelines,
          chatbot development, workflow automation, and software development.
        </p>

      </div>
    </section>
  );
};

export default Hero;
